import { useNavigate } from "react-router-dom";
import { HomeHeader } from "./home-header";
import { ArrowRight, Pencil } from "lucide-react";

export const RegisteredUserDashboardHome = () => {
  const navigate = useNavigate();
  const handleActivate = () => {
    navigate("/dashboard/activate-account");
  };

  return (
    <div>
      <HomeHeader />

      <div className="bg-gradient-to-br from-sky-50 to-blue-100 rounded-lg overflow-hidden shadow-lg border border-blue-200">
        <div className="bg-gradient-to-r from-blue-600 to-sky-500 px-5 py-4 flex items-center justify-between rounded-t-lg">
          <div className="flex items-center space-x-3">
            <Pencil className="text-white w-5 h-5" />
            <h3 className="text-base font-bold text-white">
              ¡Último paso para participar!
            </h3>
          </div>
          <span className="bg-yellow-400 text-yellow-800 text-xs font-medium px-2.5 py-1 rounded-full">
            Acción pendiente
          </span>
        </div>

        <div className="text-center p-6 sm:p-8">
          <p className="text-sm md:text-base text-gray-800 mb-5 max-w-md mx-auto">
            Completa tu información personal para activar tu cuenta y poder
            crear tu equipo.
          </p>
          <button
            onClick={handleActivate}
            className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2.5 px-5 rounded-lg text-sm flex items-center mx-auto space-x-2"
          >
            <span>Completar ahora</span>
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
